import $ from 'jquery';
import React from 'react';
import moment from 'moment';
import AmCharts from 'amcharts3-react';
import {DateField} from 'react-date-picker'
import Dummy from '../Dummy';
import styles from './style.css';
import '../../../../node_modules/amcharts3/amcharts/lang/ru.js'

require('jquery.cookie');
// import 'react-date-picker/index.css'; //TODO: import here, not in base.html

let config = {
    "type": "serial",
    "theme": "light",
    "language": "ru",
    "marginRight": 40,
    "marginLeft": 40,
    "autoMarginOffset": 20,
    "mouseWheelZoomEnabled": true,
    // "zoomOutOnDataUpdate": true,
    "dataDateFormat": "YYYY-MM-DDTJJ:NN:SS",
    "valueAxes": [{
        "id": "v1",
        "axisAlpha": 0,
        "position": "left",
        "ignoreAxisWidth": true
    }],
    "categoryAxis": {
        "parseDates": true,
        "minPeriod": "ss",
        // "equalSpacing": true,

    },
    "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        // "updateOnReleaseOnly": true,
        "offset": 30,
        "scrollbarHeight": 80,
        "backgroundAlpha": 0,
        "selectedBackgroundAlpha": 0.1,
        "selectedBackgroundColor": "#888888",
        "graphFillAlpha": 0,
        "graphLineAlpha": 0.5,
        "selectedGraphFillAlpha": 0,
        "selectedGraphLineAlpha": 1,
        "autoGridCount": true,
        "color": "#AAAAAA"
    },
    "legend": {
        "useGraphSettings": true,
        "valueText": ""
    },
    "chartCursor": {
        "pan": false,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 1,
        "cursorColor": "#258cbb",
        "valueLineAlpha": 0.2,
        "valueZoomable": false,
        "categoryBalloonDateFormat": "D MMM, JJ:NN:SS",
        "valueBalloonsEnabled": true
    },
    "valueScrollbar": {
        "oppositeAxis": false,
        "offset": 50,
        "scrollbarHeight": 10
    },
    "categoryField": "timeizm_ts",

    "export": {
        "enabled": true
    },
};

export default class Chartentry extends Dummy {
    constructor(props) {
        super(props);
        this.state.from = moment().subtract(10, 'days');
        this.state.to = moment();
        this.onFromChange = ::this.onFromChange;
        this.onToChange = ::this.onToChange;
    }

    componentWillMount() {
        this.loadChartData(this.props.ps, 'trend');
    }

    componentDidMount() {
        this.timer = true;
    }

    componentDidUpdate() {
        if (this.refs.chartref && this.refs.chartref.state.chart) {
            this.refs.chartref.state.chart.zoomOut();
        }
    }

    apiUrl(params, type) {
        // console.log('api-url');
        let url = `${this.props.base_url}/${type}/${this.props.kp}/`;
        if (this.state.from && this.state.to) {
            url += `?from=${this.state.from.format('YYYY-MM-DD')}&to=${this.state.to.format('YYYY-MM-DD')}`;
        }
        return url;
    }

    loadChartData(params, type) {
        let postData = [];
        let apiUrl = this.apiUrl(params, type);

        Object.keys(params).map(key => {
                postData.push(key);
                return null;
            }
        );

        $.ajax({
            url: apiUrl,
            cache: 'false',
            type: 'POST',
            data: JSON.stringify({data: postData}),

            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
                xhr.setRequestHeader('Content-Type', 'json');
            },
        }).done((data) => {
            this.setState({
                ps: data,
                dataReady: true
            }, () => {
                this.forceUpdate();
            });

        }).fail((err) => {
            console.log('error', err);
        });


    }

    onFromChange(dateString, dateMoment) {
        let from = dateMoment;
        if (from && from.dateMoment) {
            this.setState({
                    from: from.dateMoment,
                    dataReady: false
                }, () => {
                    this.loadChartData(this.props.ps, 'trend');
                }
            );

        }
    }

    onToChange(dateString, dateMoment) {
        let to = dateMoment;
        if (to && to.dateMoment) {
            this.setState({
                    to: to.dateMoment,
                    dataReady: false
                }, () => {
                    this.loadChartData(this.props.ps, 'trend');
                }
            );

        }
    }

    shouldComponentUpdate(nextProps, nextState) { //Will updates only after data loading in loadChartData
        return false;
    }

    render() {
        if (this.state.dataReady) {
            let graphs = [];
            Object.keys(this.props.ps).forEach((key, i) => {
                graphs.push(
                    {
                        id: key,
                        type: "step",
                        lineThickness: 2,
                        title: this.props.ps[key].caption,
                        valueField: key,
                    }
                );
            });
            config.graphs = graphs;
            config.chartScrollbar.graph = Object.keys(this.props.ps)[0];
            config.titles = [
                {
                    text: this.props.chartName,
                    size: 15
                }];
            config.valueAxes[0].title = this.props.valueTitle;
        }
        return (
            <div className={this.props.className || styles.chart}>

                <span className={styles.dates}><DateField
                    defaultValue={this.state.from.format('DD.MM.YYYY')}
                    dateFormat="DD.MM.YYYY"
                    onChange={this.onFromChange}
                    footer={false}
                    updateOnDateClick={true}
                    collapseOnDateClick={true}
                    showClock={false}
                    locale="ru"


                />
                <DateField
                    defaultValue={this.state.to.format('DD.MM.YYYY')}
                    dateFormat="DD.MM.YYYY"
                    onChange={this.onToChange}
                    footer={false}
                    updateOnDateClick={true}
                    collapseOnDateClick={true}
                    showClock={false}
                    locale="ru"

                /></span>
                {
                    (() => {
                        if (!this.state.dataReady) {
                            return (<div className={styles.loading}/>)
                        }
                        if (this.state.dataReady && this.state.ps['data'].length === 0) {
                            return (<div className={styles.loading}>Нет данных за выбранный период</div>)
                        }
                        else if (this.state.dataReady) {
                            return (<AmCharts {...config} ref='chartref' dataProvider={this.state.ps['data']}
                                              path="/amcharts"
                            />)
                        }
                    })()
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/lib/core/Chartentry/index.jsx